/**
 * Theme Configuration for NurseApp
 * 6 Themes: White, Blue, Black, Emerald, Purple, Gold
 */

export const THEMES = {
  WHITE: {
    id: 'WHITE',
    name: 'ขาว',
    nameEn: 'White',
    colors: {
      primary: '#3B82F6', // Blue
      background: '#FFFFFF',
      'secondary-bg': '#F0F5FF',
      'text-primary': '#1E293B',
      'text-secondary': '#64748B',
      'border-color': '#E2E8F0',
      accent: '#3B82F6',
      gradient: 'from-blue-500 to-blue-600'
    }
  },
  BLUE: {
    id: 'BLUE',
    name: 'น้ำเงิน',
    nameEn: 'Blue',
    colors: {
      primary: '#2563EB',
      background: '#EFF6FF',
      'secondary-bg': '#DBEAFE',
      'text-primary': '#1E3A8A',
      'text-secondary': '#3B82F6',
      'border-color': '#BFDBFE',
      accent: '#2563EB',
      gradient: 'from-blue-600 to-blue-700'
    }
  },
  BLACK: {
    id: 'BLACK',
    name: 'ดำ',
    nameEn: 'Black',
    colors: {
      primary: '#1F2937',
      background: '#111827',
      'secondary-bg': '#1F2937',
      'text-primary': '#F9FAFB',
      'text-secondary': '#D1D5DB',
      'border-color': '#374151',
      accent: '#4B5563',
      gradient: 'from-gray-800 to-gray-900'
    }
  },
  EMERALD: {
    id: 'EMERALD',
    name: 'เขียวมรกต',
    nameEn: 'Emerald',
    colors: {
      primary: '#10B981',
      background: '#ECFDF5',
      'secondary-bg': '#D1FAE5',
      'text-primary': '#065F46',
      'text-secondary': '#059669',
      'border-color': '#A7F3D0',
      accent: '#10B981',
      gradient: 'from-emerald-500 to-emerald-600'
    }
  },
  PURPLE: {
    id: 'PURPLE',
    name: 'ม่วง',
    nameEn: 'Purple',
    colors: {
      primary: '#8B5CF6',
      background: '#F5F3FF',
      'secondary-bg': '#EDE9FE',
      'text-primary': '#5B21B6',
      'text-secondary': '#7C3AED',
      'border-color': '#DDD6FE',
      accent: '#8B5CF6',
      gradient: 'from-purple-500 to-purple-600'
    }
  },
  GOLD: {
    id: 'GOLD',
    name: 'ทอง',
    nameEn: 'Gold',
    colors: {
      primary: '#F59E0B',
      background: '#FFFBEB',
      'secondary-bg': '#FEF3C7',
      'text-primary': '#92400E',
      'text-secondary': '#D97706',
      'border-color': '#FDE68A',
      accent: '#F59E0B',
      gradient: 'from-yellow-500 to-amber-600'
    }
  }
};

export const DEFAULT_THEME = THEMES.WHITE;

/**
 * Get theme by ID
 */
export const getTheme = (themeId) => {
  return THEMES[themeId] || DEFAULT_THEME;
};

/**
 * Get all themes
 */
export const getAllThemes = () => {
  return Object.values(THEMES);
};


